import Hero from '../components/Hero';
import SectionHeading from '../components/SectionHeading';
import CallToAction from '../components/CallToAction';
import { motion } from 'framer-motion';

const HowItWorks = () => {
  return (
    <>
      <Hero
        title="How PedigreePro Works"
        subtitle="Watch our comprehensive guide to learn how PedigreePro can help you manage your flock efficiently."
        image="/images/ryeland4.jpg"
      />
      
      <section className="section bg-white">
        <div className="container">
          <SectionHeading 
            title="Video Guide"
            subtitle="Watch this short video to see PedigreePro in action and learn how it can streamline your flock management."
          />
          
          <motion.div 
            className="max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="relative pb-[56.25%] h-0 rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.youtube.com/embed/D5OOuXvaHSI"
                title="How to use PedigreePro"
                className="absolute top-0 left-0 w-full h-full border-0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              ></iframe>
            </div>
          </motion.div>
          
          <motion.div 
            className="mt-12 max-w-3xl mx-auto text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="text-lg text-neutral-600 mb-8">
              This video demonstrates the key features of PedigreePro and shows you how easy it is to get started with managing your flock records.
            </p>
          </motion.div>
        </div>
      </section>
      
      <CallToAction 
        title="Ready to Get Started?"
        description="Join hundreds of sheep breeders who are already using PedigreePro to manage their flocks more efficiently."
        buttonText="Launch PedigreePro App"
        buttonLink="https://pedigreepro.netlify.app/"
        secondaryButtonText="View Subscription Plans"
        secondaryButtonLink="/subscription"
      />
    </>
  );
};

export default HowItWorks;